import React from 'react';
import WrapperValidationInputGroup from "./WrapperValidationInputGroup";
import {RequiredValidator} from "../../validator/RequiredValidators";
import PropTypes from "prop-types";
import {SelectGroup} from "../base/SelectGroup";

class Required extends React.Component {
    render() {
        return (
            <SelectGroup autoFocus={this.props.autoFocus} input={this.props.input} alert={this.props.alert} onChange={this.props.onChange}
                        onBlur={this.props.onBlur}/>
        )
    }
}

let listValidators = () => {
    let validators = [];
    validators.push(new RequiredValidator());
    return validators;
};

const validators = {
    validators: listValidators()
};

export const RequiredSelectGroup = WrapperValidationInputGroup(Required, validators);

RequiredSelectGroup.propTypes = {
    alert: PropTypes.shape({
        show: PropTypes.bool.isRequired,
        title: PropTypes.string,
        text: PropTypes.string,
        type: PropTypes.string,
        dismissible: PropTypes.bool,
    }),
    input: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string,
        disabled: PropTypes.bool,
        type: PropTypes.string,
        placeholder: PropTypes.string,
        required: PropTypes.bool,
        title: PropTypes.string,
    }).isRequired,
    validateOn: PropTypes.string
};


// WEBPACK FOOTER //
// ./src/input/validation/RequiredSelectGroup.js